module.exports = __webpack_public_path__ + "img/leaderboard-empty.4e1eae07.svg";